import React from "react";
import { Form, Button, Input, message, Select, Card, Typography, Space } from "antd";
import { UserAddOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../../shared/api/AllApi";
import { invalidateCatalog } from "../../../hooks/useCatalogData";

const { Title } = Typography;
const { Option } = Select;

const AddCustomer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const res = await apiClient.post("/customers", values);
      if (res.status === 200 || res.status === 201) {
        invalidateCatalog("customers");
        message.success(t("successMessage"));
        navigate("/GetCustomer");
      }
    } catch (error) {
      message.error(error?.response?.data?.message || t("errorMessage"));
    }
  };

  return (
    <div className="page-container">
      <div className="page-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Title level={3} style={{ margin: 0 }}>{t("addCustomer")}</Title>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/GetCustomer")}>{t("cancel")}</Button>
      </div>
      <Card className="form-card">
        <Form form={form} layout="vertical" onFinish={onFinish} requiredMark scrollToFirstError style={{ maxWidth: 640 }}>
          <Form.Item name="name" label={t("name")} rules={[{ required: true, message: t("enterName") }]}>
            <Input placeholder={t("enterName")} size="large" />
          </Form.Item>
          <Form.Item name="email" label={t("email")} rules={[{ type: "email", message: t("invalidEmail") }]}>
            <Input placeholder={t("enterEmail")} size="large" />
          </Form.Item>
          <Form.Item name="phone_number" label={t("phone")}>
            <Input placeholder={t("enterPhone")} size="large" />
          </Form.Item>
          <Form.Item name="type" label={t("type")}>
            <Select placeholder={t("selectType")} size="large" allowClear>
              <Option value="Company">{t("company")}</Option>
              <Option value="Individual">{t("individual")}</Option>
              <Option value="Organization">{t("organization")}</Option>
            </Select>
          </Form.Item>
          <Form.Item style={{ marginTop: 8 }}>
            <Space>
              <Button type="primary" htmlType="submit" icon={<UserAddOutlined />} size="large">{t("submit")}</Button>
              <Button size="large" onClick={() => form.resetFields()}>{t("reset")}</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AddCustomer;
